import React from 'react';
import styled from 'styled-components';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ListItemText from '@material-ui/core/ListItemText';

export const StyledFormControl = styled(props => <FormControl {...props} />)`
  &.MuiFormControl-root {
    width: 116px;
    position: absolute;
    right: 24px;
    top: 36px;
  }
  .MuiPopover-paper {
    max-width: 200px;
  }

  && {
    .MuiOutlinedInput-root {
      .MuiOutlinedInput-input {
        padding: 8px 30px 8px 14px;
      }
      .MuiOutlinedInput-notchedOutline {
        border-color: ${props => props.menuOpen ? '#727272' : '#a5a5a5'};
        border-width: 1px;
      }
      svg {
        margin-top: 1px;
      }
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p, svg {
        color: ${props => props.menuOpen ? '#727272' : '#a5a5a5'};
        font-weight: bold;
      }
    }
  }
`

export const StyledSelect = styled(({ className, ...props }) => (
  <Select 
    {...props}
    MenuProps={{ 
      classes: { paper: className },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      }
    }}
  />
))`
  && {
    max-width: 200px;
  }
`;

export const StyledListItemText = styled(props => <ListItemText {...props} />)`
  height: 19px;
  color: #727272;

  .MuiTypography-root {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/SwitchReport/components/PeriodSelect/style.js